import React, { ReactNode } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import useEntitiesCache, {
  UseEntitiesCacheReturnType as EntitiesCacheProps,
} from '../hooks/useEntitiesCache';

const EntitiesCacheContext = getOrCreateGlobalContext<EntitiesCacheProps>(
  CONTEXT_NAMES.EntitiesCacheContext,
);

export const useEntitiesCacheContext = () =>
  useContextWithValidation(EntitiesCacheContext, {
    hook: 'useEntitiesCacheContext',
    provider: 'EntitiesCacheProvider',
  });

const EntitiesCacheProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const contextValue = useEntitiesCache();

  return (
    <EntitiesCacheContext.Provider value={contextValue}>
      {children}
    </EntitiesCacheContext.Provider>
  );
};

EntitiesCacheProvider.displayName = 'EntitiesCacheProvider';

export default EntitiesCacheProvider;
